import moment from 'moment';

export const normalizeDate = (dateObj) => new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());

export const parseDateValue = (value) => {
    if (value instanceof Date) {
        return value;
    }

    const parsedDate = moment(value).toDate();
    if (!parsedDate || isNaN(parsedDate.getTime())) {
        return null;
    }

    return parsedDate;
};

export const isUnderMinimumAge = (minAge, value) => {
    if (minAge === null || minAge === undefined || minAge === '' || value === null || value === undefined || value === '') {
        return false;
    }

    const parsedDate = parseDateValue(value);
    if (!parsedDate) {
        return false;
    }

    const normalizedDate = normalizeDate(parsedDate);
    const today = new Date();
    const maxAllowedBirthDate = normalizeDate(new Date(
        today.getFullYear() - Number(minAge),
        today.getMonth(),
        today.getDate()
    ));

    return normalizedDate > maxAllowedBirthDate;
};